import assign from "lodash/fp/assign";
import filter from "lodash/fp/filter";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import includes from "lodash/fp/includes";
import keyBy from "lodash/fp/keyBy";
import map from "lodash/fp/map";
import pickBy from "lodash/fp/pickBy";
import moment from "moment";

import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";

class AttachmentStore {
    constructor() {
        this.bindActions(ChatActions);

        this.state = {
            attachments: {},
        };
    }

    onLoadSuccess({ question }) {
        const generateAttachments = flow(
            flatMap(response => response.messages),
            flatMap(message =>
                map(attachment =>
                    assign(attachment, {
                        messageId: message.id,
                    })
                )(message.attachments)
            ),
            keyBy("id")
        );

        this.setState({ attachments: generateAttachments(question.response) });
    }

    onLoadFail(error) {
        this.setState({ error });
    }

    onUploadAttachment({ tempId }) {
        this.setState({
            attachments: assign({
                [tempId]: {
                    id: tempId,
                    dateCreated: moment().toISOString(),
                    lastUpdated: moment().toISOString(),
                    messageId: tempId,
                    translation: "",
                    url: {
                        original: "",
                        thumbnail: "",
                    },
                },
            })(this.state.attachments),
        });
    }

    onUploadAttachmentSuccess({ attachments, id: messageId }) {
        const generateAttachments = flow(
            map(attachment => assign(attachment, { messageId })),
            keyBy("id"),
            assign(this.state.attachments),
            pickBy(attachment => !includes("tempAttachmentId_")(attachment.id))
        );

        this.setState({ attachments: generateAttachments(attachments) });
    }

    static getForMessage(messageId) {
        return filter({ messageId })(this.getState().attachments);
    }
}

export default alt.createStore(AttachmentStore, "AttachmentStore");
